let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9PpGe")).then(() => parcelRequire('41M8N'));